
export const KEY_REPORT = "report"
export const KEY_CONTENT = "content"
export const KEY_SETTINGS = "settings"
